import { Box } from "@mui/material";
import React from "react";
import { ServiceReportStatusCode, serviceReportCode } from "../customer/machinery/models/ServiceReportsModel";
import colors from "./themes/colors";
import useTranslation from "./hooks/useTranslation";

interface ServiceReportStatusCodeProps {
  sizeCode: ServiceReportStatusCode;
}

export const ServiceReportCode = ({ sizeCode }: ServiceReportStatusCodeProps) => {
  const { translate } = useTranslation("myMachinery");
  function serviceReportCode(status: ServiceReportStatusCode) {
    switch (status) {
      case ServiceReportStatusCode.inProgress:
        return translate("serviceReportStatus.inProgress");
      case ServiceReportStatusCode.solved:
        return translate("serviceReportStatus.solved");
      default:
        return "";
    }
  }
  return (
    <Box
      className="flex justify-center text-12-medium py-1"
      sx={{
        border: `1px solid ${sizeCode === ServiceReportStatusCode.inProgress ? "#FF733E" : colors.primary.green}`,
        borderRadius: "16px",
        background: sizeCode === ServiceReportStatusCode.inProgress ? "" : "#F5FFF6",
        color: sizeCode === ServiceReportStatusCode.inProgress ? "#FF733E" : colors.primary.green,
        height: "26px"
      }}
    >
      {serviceReportCode(sizeCode)}
    </Box>
  );
};